module.exports = __webpack_public_path__ + "img/crosshairs-gps.ec13cbc0.svg";